import { alpha, Tooltip } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowDownIcon, ArrowUpIcon } from 'assets/svg';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import {
  isVrsChatCollapsedSelector,
  toggleVrsChatCollapse,
} from 'features/vrs-chat/store';

export const VrsChatCollapseButton: FC = () => {
  const { t } = useTranslation('translation');
  const dispatch = useAppDispatch();
  const isCollapsed = useAppSelector(isVrsChatCollapsedSelector);

  const handleToggleCollapse = () => {
    dispatch(toggleVrsChatCollapse());
  };

  return (
    <Tooltip
      title={isCollapsed ? t('vrsChat.expand') : t('vrsChat.collapse')}
      arrow
    >
      <CollapseButton
        onClick={handleToggleCollapse}
        data-testid='vrs-chat-collapse-button'
      >
        <IconWrapper>
          {isCollapsed ? <ArrowDownIcon /> : <ArrowUpIcon />}
        </IconWrapper>
      </CollapseButton>
    </Tooltip>
  );
};

const CollapseButton = styled('button')`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${theme.spacing(4)};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: ${alpha(theme.palette.common.white, 0.7)};

  &:hover {
    background: ${alpha(theme.palette.common.white, 0.1)};
    color: ${theme.palette.common.white};
  }

  &:active {
    background: ${alpha(theme.palette.common.white, 0.2)};
  }
`;

const IconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    width: 16px;
    height: 16px;
  }
`;
